<template>
  <div class="d-flex align-center justify-center my-4">
    <!-- 前へ -->
    <v-btn
      text exact
      class="mr-4"
      :disabled="!hasPrev"
      :to="{query: {p: page - 1}}"
      replace
    >
      <v-icon>keyboard_arrow_left</v-icon>
      <span>前へ</span>
    </v-btn>

    <!-- ページ番号 -->
    <span class="body-2">{{page}} ページ</span>

    <!-- 前へ -->
    <v-btn
      text exact
      class="ml-4"
      :disabled="!hasNext"
      :to="{query: {p: page + 1}}"
      replace
    >
      <span>次へ</span>
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'CPager',
  props: {
    /**
     * ページ番号
     */
    page: {
      type: Number,
      required: true
    },

    /**
     * 前のページがあるか
     */
    hasPrev: {
      type: Boolean,
      default: false
    },

    /**
     * 次のページがあるか
     */
    hasNext: {
      type: Boolean,
      default: false
    }
  }
}
</script>
